import {AfterViewInit, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {NGXLogger} from 'ngx-logger';
import * as Sentry from '@sentry/angular';
import * as loadImage from 'blueimp-load-image';
import {FileDialogData} from '../../models/file.model';
import {FileService} from '../../services/file.service';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview-dialog.component.html',
  styleUrls: ['./file-preview-dialog.component.css']
})

export class FilePreviewDialogComponent implements OnInit, AfterViewInit {
  public file: Blob | File;
  public framed: boolean;
  public fileSrc: string | Uint8Array;
  public loading = true;

  @ViewChild('imageElement') imageElement: ElementRef;

  static open(dialog: MatDialog, data: FileDialogData, router: Router): MatDialogRef<FilePreviewDialogComponent> {
    history.pushState({}, 'Imagem do Atestado', router.url + '/dialog');
    return dialog.open(FilePreviewDialogComponent, {
      maxWidth: '100vw',
      height: '100vh',
      panelClass: 'app-full-screen-dialog',
      data,
      disableClose: true
    });
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FileDialogData,
    private dialogRef: MatDialogRef<FilePreviewDialogComponent>,
    private logger: NGXLogger,
    private renderer: Renderer2,
    private fileService: FileService
  ) {
    (window as any).pdfWorkerSrc = '/assets/js/pdf.worker.min.js';
    this.framed = !!(this.data.okButton && this.data.noButton);
    this.file = this.data.file;
  }

  ngAfterViewInit(): void {
    this.data.fileUrl ? this.getFile() : this.buildPreview();
  }

  ngOnInit(): void {
  }

  public onNoClicked(): void {
    history.back();
    this.dialogRef.close();
  }

  public onOkClicked(): void {
    history.back();
    this.dialogRef.close({
      label: this.fileSrc,
      value: this.file
    });
  }

  private getFile(): void {
    this.fileService.getFile(this.data.fileUrl)
      .subscribe(
        blob => this.fileLoaded(blob),
        error => this.logger.error(error)
      );
  }

  private fileLoaded(blob: Blob): void {
    this.file = blob;
    this.buildPreview();
  }

  private buildPreview(): void {
    if (this.file.type === 'application/pdf') {
      const reader = new FileReader();

      reader.addEventListener('load', () => {
        if (typeof reader.result === 'string') {
          this.fileSrc = reader.result;
        } else {
          this.fileSrc = new Uint8Array(reader.result);
        }
      });
      reader.readAsArrayBuffer(this.file);

    } else if (this.file.type?.includes('image/')) {
      loadImage(this.file, {maxWidth: 1200, orientation: true, meta: true})
        .then((data) => {
          this.renderer.appendChild(this.imageElement.nativeElement, data.image);
          this.loading = false;
          this.fileSrc = '';
        })
        .catch((e) => {
          console.error(e);
          this.loading = false;
          Sentry.captureMessage(`Error loading image: ${this.file.type}`);
          Sentry.captureException(e);
        });
    } else {
      this.loading = false;
      Sentry.captureMessage(`File type not accepted: ${this.file.type}`);
      // TODO type not accepted
    }
  }
}
